module.exports.AcademicCapIcon = require("./AcademicCapIcon.js")
module.exports.AdjustmentsHorizontalIcon = require("./AdjustmentsHorizontalIcon.js")
module.exports.AdjustmentsVerticalIcon = require("./AdjustmentsVerticalIcon.js")
module.exports.ArchiveBoxArrowDownIcon = require("./ArchiveBoxArrowDownIcon.js")
module.exports.ArchiveBoxXMarkIcon = require("./ArchiveBoxXMarkIcon.js")
module.exports.ArchiveBoxIcon = require("./ArchiveBoxIcon.js")
module.exports.ArrowDownCircleIcon = require("./ArrowDownCircleIcon.js")
module.exports.ArrowDownLeftIcon = require("./ArrowDownLeftIcon.js")
module.exports.ArrowDownOnSquareStackIcon = require("./ArrowDownOnSquareStackIcon.js")
module.exports.ArrowDownOnSquareIcon = require("./ArrowDownOnSquareIcon.js")
module.exports.ArrowDownRightIcon = require("./ArrowDownRightIcon.js")
module.exports.ArrowDownTrayIcon = require("./ArrowDownTrayIcon.js")
module.exports.ArrowDownIcon = require("./ArrowDownIcon.js")
module.exports.ArrowLeftCircleIcon = require("./ArrowLeftCircleIcon.js")
module.exports.ArrowLeftOnRectangleIcon = require("./ArrowLeftOnRectangleIcon.js")
module.exports.ArrowLeftIcon = require("./ArrowLeftIcon.js")
module.exports.ArrowLongDownIcon = require("./ArrowLongDownIcon.js")
module.exports.ArrowLongLeftIcon = require("./ArrowLongLeftIcon.js")
module.exports.ArrowLongRightIcon = require("./ArrowLongRightIcon.js")
module.exports.ArrowLongUpIcon = require("./ArrowLongUpIcon.js")
module.exports.ArrowPathRoundedSquareIcon = require("./ArrowPathRoundedSquareIcon.js")
module.exports.ArrowPathIcon = require("./ArrowPathIcon.js")
module.exports.ArrowRightCircleIcon = require("./ArrowRightCircleIcon.js")
module.exports.ArrowRightOnRectangleIcon = require("./ArrowRightOnRectangleIcon.js")
module.exports.ArrowRightIcon = require("./ArrowRightIcon.js")
module.exports.ArrowSmallDownIcon = require("./ArrowSmallDownIcon.js")
module.exports.ArrowSmallLeftIcon = require("./ArrowSmallLeftIcon.js")
module.exports.ArrowSmallRightIcon = require("./ArrowSmallRightIcon.js")
module.exports.ArrowSmallUpIcon = require("./ArrowSmallUpIcon.js")
module.exports.ArrowTopRightOnSquareIcon = require("./ArrowTopRightOnSquareIcon.js")
module.exports.ArrowTrendingDownIcon = require("./ArrowTrendingDownIcon.js")
module.exports.ArrowTrendingUpIcon = require("./ArrowTrendingUpIcon.js")
module.exports.ArrowUpCircleIcon = require("./ArrowUpCircleIcon.js")
module.exports.ArrowUpLeftIcon = require("./ArrowUpLeftIcon.js")
module.exports.ArrowUpOnSquareStackIcon = require("./ArrowUpOnSquareStackIcon.js")
module.exports.ArrowUpOnSquareIcon = require("./ArrowUpOnSquareIcon.js")
module.exports.ArrowUpRightIcon = require("./ArrowUpRightIcon.js")
module.exports.ArrowUpTrayIcon = require("./ArrowUpTrayIcon.js")
module.exports.ArrowUpIcon = require("./ArrowUpIcon.js")
module.exports.ArrowUturnDownIcon = require("./ArrowUturnDownIcon.js")
module.exports.ArrowUturnLeftIcon = require("./ArrowUturnLeftIcon.js")
module.exports.ArrowUturnRightIcon = require("./ArrowUturnRightIcon.js")
module.exports.ArrowUturnUpIcon = require("./ArrowUturnUpIcon.js")
module.exports.ArrowsPointingInIcon = require("./ArrowsPointingInIcon.js")
module.exports.ArrowsPointingOutIcon = require("./ArrowsPointingOutIcon.js")
module.exports.ArrowsRightLeftIcon = require("./ArrowsRightLeftIcon.js")
module.exports.ArrowsUpDownIcon = require("./ArrowsUpDownIcon.js")
module.exports.AtSymbolIcon = require("./AtSymbolIcon.js")
module.exports.BackspaceIcon = require("./BackspaceIcon.js")
module.exports.BackwardIcon = require("./BackwardIcon.js")
module.exports.BanknotesIcon = require("./BanknotesIcon.js")
module.exports.Bars2Icon = require("./Bars2Icon.js")
module.exports.Bars3BottomLeftIcon = require("./Bars3BottomLeftIcon.js")
module.exports.Bars3BottomRightIcon = require("./Bars3BottomRightIcon.js")
module.exports.Bars3CenterLeftIcon = require("./Bars3CenterLeftIcon.js")
module.exports.Bars3Icon = require("./Bars3Icon.js")
module.exports.Bars4Icon = require("./Bars4Icon.js")
module.exports.BarsArrowDownIcon = require("./BarsArrowDownIcon.js")
module.exports.BarsArrowUpIcon = require("./BarsArrowUpIcon.js")
module.exports.Battery0Icon = require("./Battery0Icon.js")
module.exports.Battery100Icon = require("./Battery100Icon.js")
module.exports.Battery50Icon = require("./Battery50Icon.js")
module.exports.BeakerIcon = require("./BeakerIcon.js")
module.exports.BellAlertIcon = require("./BellAlertIcon.js")
module.exports.BellSlashIcon = require("./BellSlashIcon.js")
module.exports.BellSnoozeIcon = require("./BellSnoozeIcon.js")
module.exports.BellIcon = require("./BellIcon.js")
module.exports.BoltSlashIcon = require("./BoltSlashIcon.js")
module.exports.BoltIcon = require("./BoltIcon.js")
module.exports.BookOpenIcon = require("./BookOpenIcon.js")
module.exports.BookmarkSlashIcon = require("./BookmarkSlashIcon.js")
module.exports.BookmarkSquareIcon = require("./BookmarkSquareIcon.js")
module.exports.BookmarkIcon = require("./BookmarkIcon.js")
module.exports.BriefcaseIcon = require("./BriefcaseIcon.js")
module.exports.BugAntIcon = require("./BugAntIcon.js")
module.exports.BuildingLibraryIcon = require("./BuildingLibraryIcon.js")
module.exports.BuildingOffice2Icon = require("./BuildingOffice2Icon.js")
module.exports.BuildingOfficeIcon = require("./BuildingOfficeIcon.js")
module.exports.BuildingStorefrontIcon = require("./BuildingStorefrontIcon.js")
module.exports.CakeIcon = require("./CakeIcon.js")
module.exports.CalculatorIcon = require("./CalculatorIcon.js")
module.exports.CalendarDaysIcon = require("./CalendarDaysIcon.js")
module.exports.CalendarIcon = require("./CalendarIcon.js")
module.exports.CameraIcon = require("./CameraIcon.js")
module.exports.ChartBarSquareIcon = require("./ChartBarSquareIcon.js")
module.exports.ChartBarIcon = require("./ChartBarIcon.js")
module.exports.ChartPieIcon = require("./ChartPieIcon.js")
module.exports.ChatBubbleBottomCenterTextIcon = require("./ChatBubbleBottomCenterTextIcon.js")
module.exports.ChatBubbleBottomCenterIcon = require("./ChatBubbleBottomCenterIcon.js")
module.exports.ChatBubbleLeftEllipsisIcon = require("./ChatBubbleLeftEllipsisIcon.js")
module.exports.ChatBubbleLeftRightIcon = require("./ChatBubbleLeftRightIcon.js")
module.exports.ChatBubbleLeftIcon = require("./ChatBubbleLeftIcon.js")
module.exports.ChatBubbleOvalLeftEllipsisIcon = require("./ChatBubbleOvalLeftEllipsisIcon.js")
module.exports.ChatBubbleOvalLeftIcon = require("./ChatBubbleOvalLeftIcon.js")
module.exports.CheckBadgeIcon = require("./CheckBadgeIcon.js")
module.exports.CheckCircleIcon = require("./CheckCircleIcon.js")
module.exports.CheckIcon = require("./CheckIcon.js")
module.exports.ChevronDoubleDownIcon = require("./ChevronDoubleDownIcon.js")
module.exports.ChevronDoubleLeftIcon = require("./ChevronDoubleLeftIcon.js")
module.exports.ChevronDoubleRightIcon = require("./ChevronDoubleRightIcon.js")
module.exports.ChevronDoubleUpIcon = require("./ChevronDoubleUpIcon.js")
module.exports.ChevronDownIcon = require("./ChevronDownIcon.js")
module.exports.ChevronLeftIcon = require("./ChevronLeftIcon.js")
module.exports.ChevronRightIcon = require("./ChevronRightIcon.js")
module.exports.ChevronUpDownIcon = require("./ChevronUpDownIcon.js")
module.exports.ChevronUpIcon = require("./ChevronUpIcon.js")
module.exports.CircleStackIcon = require("./CircleStackIcon.js")
module.exports.ClipboardDocumentCheckIcon = require("./ClipboardDocumentCheckIcon.js")
module.exports.ClipboardDocumentListIcon = require("./ClipboardDocumentListIcon.js")
module.exports.ClipboardDocumentIcon = require("./ClipboardDocumentIcon.js")
module.exports.ClipboardIcon = require("./ClipboardIcon.js")
module.exports.ClockIcon = require("./ClockIcon.js")
module.exports.CloudArrowDownIcon = require("./CloudArrowDownIcon.js")
module.exports.CloudArrowUpIcon = require("./CloudArrowUpIcon.js")
module.exports.CloudIcon = require("./CloudIcon.js")
module.exports.CodeBracketSquareIcon = require("./CodeBracketSquareIcon.js")
module.exports.CodeBracketIcon = require("./CodeBracketIcon.js")
module.exports.Cog6ToothIcon = require("./Cog6ToothIcon.js")
module.exports.Cog8ToothIcon = require("./Cog8ToothIcon.js")
module.exports.CogIcon = require("./CogIcon.js")
module.exports.CommandLineIcon = require("./CommandLineIcon.js")
module.exports.ComputerDesktopIcon = require("./ComputerDesktopIcon.js")
module.exports.CpuChipIcon = require("./CpuChipIcon.js")
module.exports.CreditCardIcon = require("./CreditCardIcon.js")
module.exports.CubeTransparentIcon = require("./CubeTransparentIcon.js")
module.exports.CubeIcon = require("./CubeIcon.js")
module.exports.CurrencyBangladeshiIcon = require("./CurrencyBangladeshiIcon.js")
module.exports.CurrencyDollarIcon = require("./CurrencyDollarIcon.js")
module.exports.CurrencyEuroIcon = require("./CurrencyEuroIcon.js")
module.exports.CurrencyPoundIcon = require("./CurrencyPoundIcon.js")
module.exports.CurrencyRupeeIcon = require("./CurrencyRupeeIcon.js")
module.exports.CurrencyYenIcon = require("./CurrencyYenIcon.js")
module.exports.CursorArrowRaysIcon = require("./CursorArrowRaysIcon.js")
module.exports.CursorArrowRippleIcon = require("./CursorArrowRippleIcon.js")
module.exports.DevicePhoneMobileIcon = require("./DevicePhoneMobileIcon.js")
module.exports.DeviceTabletIcon = require("./DeviceTabletIcon.js")
module.exports.DocumentArrowDownIcon = require("./DocumentArrowDownIcon.js")
module.exports.DocumentArrowUpIcon = require("./DocumentArrowUpIcon.js")
module.exports.DocumentChartBarIcon = require("./DocumentChartBarIcon.js")
module.exports.DocumentCheckIcon = require("./DocumentCheckIcon.js")
module.exports.DocumentDuplicateIcon = require("./DocumentDuplicateIcon.js")
module.exports.DocumentMagnifyingGlassIcon = require("./DocumentMagnifyingGlassIcon.js")
module.exports.DocumentMinusIcon = require("./DocumentMinusIcon.js")
module.exports.DocumentPlusIcon = require("./DocumentPlusIcon.js")
module.exports.DocumentTextIcon = require("./DocumentTextIcon.js")
module.exports.DocumentIcon = require("./DocumentIcon.js")
module.exports.EllipsisHorizontalCircleIcon = require("./EllipsisHorizontalCircleIcon.js")
module.exports.EllipsisHorizontalIcon = require("./EllipsisHorizontalIcon.js")
module.exports.EllipsisVerticalIcon = require("./EllipsisVerticalIcon.js")
module.exports.EnvelopeOpenIcon = require("./EnvelopeOpenIcon.js")
module.exports.EnvelopeIcon = require("./EnvelopeIcon.js")
module.exports.ExclamationCircleIcon = require("./ExclamationCircleIcon.js")
module.exports.ExclamationTriangleIcon = require("./ExclamationTriangleIcon.js")
module.exports.EyeDropperIcon = require("./EyeDropperIcon.js")
module.exports.EyeSlashIcon = require("./EyeSlashIcon.js")
module.exports.EyeIcon = require("./EyeIcon.js")
module.exports.FaceFrownIcon = require("./FaceFrownIcon.js")
module.exports.FaceSmileIcon = require("./FaceSmileIcon.js")
module.exports.FilmIcon = require("./FilmIcon.js")
module.exports.FingerPrintIcon = require("./FingerPrintIcon.js")
module.exports.FireIcon = require("./FireIcon.js")
module.exports.FlagIcon = require("./FlagIcon.js")
module.exports.FolderArrowDownIcon = require("./FolderArrowDownIcon.js")
module.exports.FolderMinusIcon = require("./FolderMinusIcon.js")
module.exports.FolderOpenIcon = require("./FolderOpenIcon.js")
module.exports.FolderPlusIcon = require("./FolderPlusIcon.js")
module.exports.FolderIcon = require("./FolderIcon.js")
module.exports.ForwardIcon = require("./ForwardIcon.js")
module.exports.FunnelIcon = require("./FunnelIcon.js")
module.exports.GifIcon = require("./GifIcon.js")
module.exports.GiftTopIcon = require("./GiftTopIcon.js")
module.exports.GiftIcon = require("./GiftIcon.js")
module.exports.GlobeAltIcon = require("./GlobeAltIcon.js")
module.exports.GlobeAmericasIcon = require("./GlobeAmericasIcon.js")
module.exports.GlobeAsiaAustraliaIcon = require("./GlobeAsiaAustraliaIcon.js")
module.exports.GlobeEuropeAfricaIcon = require("./GlobeEuropeAfricaIcon.js")
module.exports.HandRaisedIcon = require("./HandRaisedIcon.js")
module.exports.HandThumbDownIcon = require("./HandThumbDownIcon.js")
module.exports.HandThumbUpIcon = require("./HandThumbUpIcon.js")
module.exports.HashtagIcon = require("./HashtagIcon.js")
module.exports.HeartIcon = require("./HeartIcon.js")
module.exports.HomeModernIcon = require("./HomeModernIcon.js")
module.exports.HomeIcon = require("./HomeIcon.js")
module.exports.IdentificationIcon = require("./IdentificationIcon.js")
module.exports.InboxArrowDownIcon = require("./InboxArrowDownIcon.js")
module.exports.InboxStackIcon = require("./InboxStackIcon.js")
module.exports.InboxIcon = require("./InboxIcon.js")
module.exports.InformationCircleIcon = require("./InformationCircleIcon.js")
module.exports.KeyIcon = require("./KeyIcon.js")
module.exports.LanguageIcon = require("./LanguageIcon.js")
module.exports.LifebuoyIcon = require("./LifebuoyIcon.js")
module.exports.LightBulbIcon = require("./LightBulbIcon.js")
module.exports.LinkIcon = require("./LinkIcon.js")
module.exports.ListBulletIcon = require("./ListBulletIcon.js")
module.exports.LockClosedIcon = require("./LockClosedIcon.js")
module.exports.LockOpenIcon = require("./LockOpenIcon.js")
module.exports.MagnifyingGlassCircleIcon = require("./MagnifyingGlassCircleIcon.js")
module.exports.MagnifyingGlassMinusIcon = require("./MagnifyingGlassMinusIcon.js")
module.exports.MagnifyingGlassPlusIcon = require("./MagnifyingGlassPlusIcon.js")
module.exports.MagnifyingGlassIcon = require("./MagnifyingGlassIcon.js")
module.exports.MapPinIcon = require("./MapPinIcon.js")
module.exports.MapIcon = require("./MapIcon.js")
module.exports.MegaphoneIcon = require("./MegaphoneIcon.js")
module.exports.MicrophoneIcon = require("./MicrophoneIcon.js")
module.exports.MinusCircleIcon = require("./MinusCircleIcon.js")
module.exports.MinusSmallIcon = require("./MinusSmallIcon.js")
module.exports.MinusIcon = require("./MinusIcon.js")
module.exports.MoonIcon = require("./MoonIcon.js")
module.exports.MusicalNoteIcon = require("./MusicalNoteIcon.js")
module.exports.NewspaperIcon = require("./NewspaperIcon.js")
module.exports.NoSymbolIcon = require("./NoSymbolIcon.js")
module.exports.PaintBrushIcon = require("./PaintBrushIcon.js")
module.exports.PaperAirplaneIcon = require("./PaperAirplaneIcon.js")
module.exports.PaperClipIcon = require("./PaperClipIcon.js")
module.exports.PauseCircleIcon = require("./PauseCircleIcon.js")
module.exports.PauseIcon = require("./PauseIcon.js")
module.exports.PencilSquareIcon = require("./PencilSquareIcon.js")
module.exports.PencilIcon = require("./PencilIcon.js")
module.exports.PhoneArrowDownLeftIcon = require("./PhoneArrowDownLeftIcon.js")
module.exports.PhoneArrowUpRightIcon = require("./PhoneArrowUpRightIcon.js")
module.exports.PhoneXMarkIcon = require("./PhoneXMarkIcon.js")
module.exports.PhoneIcon = require("./PhoneIcon.js")
module.exports.PhotoIcon = require("./PhotoIcon.js")
module.exports.PlayCircleIcon = require("./PlayCircleIcon.js")
module.exports.PlayPauseIcon = require("./PlayPauseIcon.js")
module.exports.PlayIcon = require("./PlayIcon.js")
module.exports.PlusCircleIcon = require("./PlusCircleIcon.js")
module.exports.PlusSmallIcon = require("./PlusSmallIcon.js")
module.exports.PlusIcon = require("./PlusIcon.js")
module.exports.PowerIcon = require("./PowerIcon.js")
module.exports.PresentationChartBarIcon = require("./PresentationChartBarIcon.js")
module.exports.PresentationChartLineIcon = require("./PresentationChartLineIcon.js")
module.exports.PrinterIcon = require("./PrinterIcon.js")
module.exports.PuzzlePieceIcon = require("./PuzzlePieceIcon.js")
module.exports.QrCodeIcon = require("./QrCodeIcon.js")
module.exports.QuestionMarkCircleIcon = require("./QuestionMarkCircleIcon.js")
module.exports.QueueListIcon = require("./QueueListIcon.js")
module.exports.RadioIcon = require("./RadioIcon.js")
module.exports.ReceiptPercentIcon = require("./ReceiptPercentIcon.js")
module.exports.ReceiptRefundIcon = require("./ReceiptRefundIcon.js")
module.exports.RectangleGroupIcon = require("./RectangleGroupIcon.js")
module.exports.RectangleStackIcon = require("./RectangleStackIcon.js")
module.exports.RocketLaunchIcon = require("./RocketLaunchIcon.js")
module.exports.RssIcon = require("./RssIcon.js")
module.exports.ScaleIcon = require("./ScaleIcon.js")
module.exports.ScissorsIcon = require("./ScissorsIcon.js")
module.exports.ServerStackIcon = require("./ServerStackIcon.js")
module.exports.ServerIcon = require("./ServerIcon.js")
module.exports.ShareIcon = require("./ShareIcon.js")
module.exports.ShieldCheckIcon = require("./ShieldCheckIcon.js")
module.exports.ShieldExclamationIcon = require("./ShieldExclamationIcon.js")
module.exports.ShoppingBagIcon = require("./ShoppingBagIcon.js")
module.exports.ShoppingCartIcon = require("./ShoppingCartIcon.js")
module.exports.SignalSlashIcon = require("./SignalSlashIcon.js")
module.exports.SignalIcon = require("./SignalIcon.js")
module.exports.SparklesIcon = require("./SparklesIcon.js")
module.exports.SpeakerWaveIcon = require("./SpeakerWaveIcon.js")
module.exports.SpeakerXMarkIcon = require("./SpeakerXMarkIcon.js")
module.exports.Square2StackIcon = require("./Square2StackIcon.js")
module.exports.Square3Stack3DIcon = require("./Square3Stack3DIcon.js")
module.exports.Squares2X2Icon = require("./Squares2X2Icon.js")
module.exports.SquaresPlusIcon = require("./SquaresPlusIcon.js")
module.exports.StarIcon = require("./StarIcon.js")
module.exports.StopCircleIcon = require("./StopCircleIcon.js")
module.exports.StopIcon = require("./StopIcon.js")
module.exports.SunIcon = require("./SunIcon.js")
module.exports.SwatchIcon = require("./SwatchIcon.js")
module.exports.TableCellsIcon = require("./TableCellsIcon.js")
module.exports.TagIcon = require("./TagIcon.js")
module.exports.TicketIcon = require("./TicketIcon.js")
module.exports.TrashIcon = require("./TrashIcon.js")
module.exports.TrophyIcon = require("./TrophyIcon.js")
module.exports.TruckIcon = require("./TruckIcon.js")
module.exports.TvIcon = require("./TvIcon.js")
module.exports.UserCircleIcon = require("./UserCircleIcon.js")
module.exports.UserGroupIcon = require("./UserGroupIcon.js")
module.exports.UserMinusIcon = require("./UserMinusIcon.js")
module.exports.UserPlusIcon = require("./UserPlusIcon.js")
module.exports.UserIcon = require("./UserIcon.js")
module.exports.UsersIcon = require("./UsersIcon.js")
module.exports.VariableIcon = require("./VariableIcon.js")
module.exports.VideoCameraSlashIcon = require("./VideoCameraSlashIcon.js")
module.exports.VideoCameraIcon = require("./VideoCameraIcon.js")
module.exports.ViewColumnsIcon = require("./ViewColumnsIcon.js")
module.exports.ViewfinderCircleIcon = require("./ViewfinderCircleIcon.js")
module.exports.WalletIcon = require("./WalletIcon.js")
module.exports.WifiIcon = require("./WifiIcon.js")
module.exports.WindowIcon = require("./WindowIcon.js")
module.exports.WrenchScrewdriverIcon = require("./WrenchScrewdriverIcon.js")
module.exports.WrenchIcon = require("./WrenchIcon.js")
module.exports.XCircleIcon = require("./XCircleIcon.js")
module.exports.XMarkIcon = require("./XMarkIcon.js")